import PropTypes from 'prop-types';
import { sum } from 'lodash';
import { useMemo } from 'react';
import { Page, View, Text, Image, Document, Font, StyleSheet, PDFViewer } from '@react-pdf/renderer';
import { Box, Dialog, Stack } from '@mui/material';
// utils
import { fDate, fTime } from '../../../../util/formatTime.js';
import { fCurrency } from '../../../../util/format-number.js';
import { text } from 'body-parser';

// ----------------------------------------------------------------------

Font.register({
  family: 'Ubuntu',
  fontStyle: "normal",
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
    },
    {
      src: 'https://fonts.gstatic.com/s/questrial/v13/QdVUSTchPBm7nuUeVf7EuStkm20oJA.ttf',
      fontWeight: 'bold',
    }
  ],
});

const useStyles = () =>
  useMemo(
    () =>
      StyleSheet.create({
        col0: { width: '5%' },
        col1: { width: '10%' },
        col2: { width: '20%' },
        colx: { width: '30%' },
        col3: { width: '80%' },
        col4: { width: '25%' },
        col8: { width: '75%' },
        col6: { width: '50%' },
        col7: { width: '100%' },
        col9: { width: '70%' },
        col35: { width: '35%' },
        col45: { width: '45%' },
        mt1: { marginTop: 2 },
        p1: { paddingTop: 11 },
        mtop4: {marginTop: 8},
        mb8: { marginBottom: 8 },
        mb4: { marginBottom: 4 },
        mb8: { marginBottom: 8 },
        mb40: { marginBottom: 40 },
        h3: { fontSize: 16, fontWeight: 700 },
        h4: { fontSize: 13, fontWeight: 700 },
        body1: { fontSize: 10 },
        body_1: { fontSize: 10, textTransform: 'lowercase' },
        body2: { fontSize: 9 },
        subtitle1: { fontSize: 12, fontWeight: 800},
        subtitle1_1: { fontSize: 12, fontWeight: 800, textTransform: 'lowercase'},
        titleHeader: {fontFamily: 'Helvetica-Bold', fontWeight: 900, fontSize: 12},
        subtitle2: { fontSize: 10, fontWeight: 700 },
        alignRight: { textAlign: 'right' },
        alignCenter: { textAlign: 'center' },
        textMargin: {margin: 2},
        textMarginheader: {
          marginLeft: 1
        },
        textMargin_1: {
          margin: 1,
          textAlign: 'center'
        },
        textMargin_x1: {
          margin: 1,
          textAlign: 'left'
        },
        textMargin_2: {
          margin: 1,
          textAlign: 'center'
        },
        textMargin_3: {
          margin: 1
        },
        page: {
          fontSize: 9,
          lineHeight: 1.6,
          fontFamily: 'Ubuntu',
          backgroundColor: '#FFFFFF',
          padding: '40px 24px 40px 24px',
        },
        footer: {
          left: 0,
          right: 0,
          bottom: 0,
          padding: 24,
          margin: 'auto',
          borderTopWidth: 1,
          borderStyle: 'solid',
          position: 'absolute',
          borderColor: '#DFE3E8',
        },
        gridContainer: {
          flexDirection: 'row',
          justifyContent: 'space-between',
        },
        table: {
          display: 'flex',
          width: 'auto',
        },
        tableRow: {
          flexDirection: 'row',
          borderWidth: 0.5,
          borderStyle: 'solid',
          borderColor: '#000000',
        },
        tableRowHead: {
          flexDirection: 'row',
          borderWidth: 0.5,
          borderStyle: 'solid',
          color: "#ffffff",
          borderColor: '#000000',
        },

        tableRowTop: {
          flexDirection: 'row',
          borderWidth: 0.5,
          borderStyle: 'solid',
          color: "#ffffff",
          backgroundColor: "green",
          borderColor: '#000000',
        },

        
        tableRow1: {
          flexDirection: 'row',
        },
        
        noBorder: {
          paddingTop: 8,
          paddingBottom: 0,
          borderBottomWidth: 0,
        },
        tableCell_1: {
          width: '50%',
        },
        tableCell_2: {
          width: '30%'
        },
        tableCell_3: {
          width: '30%',
        },
        tableCell_4: {
          width: '70%',
        },
        greenColor: {
          backgroundColor: "#3fb541",
          borderWidth: 0.5,
          borderStyle: 'solid',
          borderColor: '#000000',
        },
        grayColor: {
          backgroundColor: "#878a87",
          width: '100%'
        },
        whiteColor: {
          backgroundColor: "#ffffff",
          width: '100%'
        },
        resultAtt: {
          borderLeftWidth: 0.5,
          borderStyle: 'solid',
          borderColor: '#000000',
        },
        titleheader: {
          backgroundColor: "#ffffff",
          borderLeftWidth: 0.5,
          borderStyle: 'solid',
          borderColor: '#000000',
        },
        titleheader1: {
          backgroundColor: "#ffffff"
        },
        textTrans: { fontSize: 10, textTransform: 'none' },
      }),
    []
);

// ----------------------------------------------------------------------

export default function CourseSummaryPDF({ course, total, companyProfile, searchText }) {
  const styles = useStyles();
  const logo =  companyProfile ? `${process.env.PUBLIC_URL}/logo/${companyProfile?.companyName}/${companyProfile?.logo}` : null;
  const dateFrom = searchText?.dateFrom ? fDate(searchText?.dateFrom)  : null;
  const dateTo = searchText?.dateTo ? fDate(searchText?.dateTo)  : null;
  const defaultDate = dateFrom && dateTo ? `Course Start Date From: ${dateFrom} to ${dateTo}` : 'All Dates'

  return (
 
    <Document>
      <Page size="A4" style={styles.page} orientation='landscape'>
        {
          logo ?
          <View style={[styles.table, styles.mb8]}>
              <View style={styles.tableRow1}>
                  <View style={styles.col2}>
                      <Image source={logo} style={{ width: 80, height: 80 }} />
                  </View>
                  <View style={styles.col3}>
                    <Text style={styles.titleHeader}>{companyProfile?.companyName}</Text>
                    <Text style={styles.body1}>{`Address: ${companyProfile?.address}`}</Text>
                    <Text style={styles.body1}>{`Contact No: ${companyProfile?.contactNo}`}</Text>
                    <Text style={styles.body1}>{`Email: ${companyProfile?.email}`}</Text>
                </View>
                </View>
            </View>
          :
          ""
        }
            <Text style={[styles.titleHeader, styles.textMargin]}>{`Course Breakdown Summary Report`}</Text>
            <View style={[styles.table, styles.mb8]}>
            <View style={styles.tableRow1}>
                  <View style={styles.col6}>
                      <Text style={[styles.body2, styles.textMarginheader]}>{`Report Generated Date: ${fDate(new Date())}`}</Text>
                  </View>
                  <View style={styles.col6}>
                      <Text style={[styles.body2, styles.textMarginheader]}>{defaultDate}</Text>
                  </View>
                  </View>
              </View>

           <View style={styles.table}>
            <View>
              <View style={styles.tableRowTop}>
                <View style={[styles.tableCell_4, styles.col0, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_2]}>S/N</Text>
                </View>
                
                <View style={[styles.tableCell_4,  styles.col45, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>Course Title</Text>
                </View>
                <View style={[styles.tableCell_4,  styles.col1, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>Total Confirmed Classes</Text>
                </View>
                <View style={[styles.tableCell_4,  styles.col1, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>Total Completed Classes</Text>
                </View>
                <View style={[styles.tableCell_4,  styles.col1, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>Total Draft Classes</Text>
                </View>
                <View style={[styles.tableCell_4, styles.col1, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>Total Classes</Text>
                </View>
                <View style={[styles.tableCell_4, styles.col1, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>Total Trainees</Text>
                </View>
              </View>
            </View>
           

                {course?.map((res, i) => {
     
                  return(
                    <View style={styles.tableRow} wrap={false}>
                    <View style={[styles.tableCell_4, styles.col0, styles.resultAtt]}>
                      <Text style={[styles.body2, styles.textMargin]}>{`${i + 1}`}</Text>
                    </View>
                    <View style={[styles.tableCell_4,  styles.col45, styles.resultAtt]}>
                      <Text style={[styles.body2, styles.textMargin]}>{res?._id}</Text>
                    </View>
                    <View style={[styles.tableCell_4,  styles.col1, styles.resultAtt]}>
                      <Text style={[styles.body2, styles.textMargin_1]}>{res?.totalConfirmedClasses}</Text>
                    </View>
                    <View style={[styles.tableCell_4,  styles.col1, styles.resultAtt]}>
                      <Text style={[styles.body2, styles.textMargin_1]}>{res?.totalCompletedClasses}</Text>
                    </View>
                    <View style={[styles.tableCell_4,  styles.col1, styles.resultAtt]}>
                    <Text style={[styles.body2, styles.textMargin_1]}>{res?.totalDraftClasses}</Text>
                    </View>
                    <View style={[styles.tableCell_4,  styles.col1, styles.resultAtt]}>
                    <Text style={[styles.body2, styles.textMargin_1]}>{res?.totalClasses}</Text>
                    </View>
                    <View style={[styles.tableCell_4,  styles.col1, styles.resultAtt]}>
                    <Text style={[styles.body2, styles.textMargin_1]}>{res?.countConfirmedTrainee || res?.countDraftTrainee}</Text>
                    </View>
               </View>
                  )
                })}
             <View style={styles.tableRow} wrap={false}>
                <View style={[styles.tableCell_4, styles.col0, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_2]}></Text>
                </View>
                 <View style={[styles.tableCell_4,  styles.col45, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>Total</Text>
                </View>
                <View style={[styles.tableCell_4,  styles.col1, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>{total?.totalConfirmed}</Text>
                </View>
                <View style={[styles.tableCell_4,  styles.col1, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>{total?.totalCompleted}</Text>
                </View>
                <View style={[styles.tableCell_4,  styles.col1, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>{total?.totalDraft}</Text>
                </View>
                <View style={[styles.tableCell_4, styles.col1, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>{total?.totalClasses}</Text>
                </View>
                <View style={[styles.tableCell_4, styles.col1, styles.resultAtt]}>
                  <Text style={[styles.body2, styles.textMargin_1]}>{total?.totalTrainee || total?.totalTraineeDraft}</Text>
                </View>

             </View>
           
            <View>

    
               
            </View>
          </View>
  


      </Page>
    </Document>

  );
}

CourseSummaryPDF.propTypes = {
  attendance: PropTypes.object,
  companyProfile: PropTypes.object
}